/** @format */

const FormFields = ({ onChangeValue, eventContext, fieldChange }) => {
  return (
    <div className='col-12'>
      <div className='d-flex flex-column justify-content-start'>
        <h1 className='text-dark f-14 font-weight-bold'>فیلد ها</h1>
      </div>
      <div
        className='d-flex flex-row flex-wrap justify-content-between overflow-auto border p-2'
        style={{ maxHeight: '300px' }}
      >
        {eventContext.fields?.map((item) => (
          <div className='d-flex flex-column my-1 justify-content-center border rounded p-2'>
           
            <span className='text-dark f-14 border-bottom py-2 text-center'>
              {item.label}
            </span>
            {item.type == 'img' && (
              <div className='d-flex flex-row justify-content-around'>
                <div className='form-group my-2 mx-1'>
                  <label>عرض</label>
                  
                  <input
                    type='number'
                    value={eventContext.idCardFields?.fields?.find(f=>f?.name == item?.name)?.['width_' + item?.name]}
                    onChange={(e) =>
                      onChangeValue(
                        `width_${item.name}`,
                        e.target.value,
                        fieldChange.image,
                        item.name,
                        item.label,
                        'img',
                      )
                    }
                    className='form-control f-12'
                  />
                </div>
                <div className='form-group my-2 mx-1'>
                  <label>ارتفاع</label>
                  <input
                    value={eventContext.idCardFields?.fields?.find(f=>f?.name == item?.name)?.['height_' + item?.name]}
                    type='number'
                    onChange={(e) =>
                      onChangeValue(
                        `height_${item.name}`,
                        e.target.value,
                        fieldChange.image,
                        item.name,
                        item.label,
                      )
                    }
                    className='form-control f-12'
                  />
                </div>
              </div>
            )}
            <div className='d-flex flex-row justify-content-around'>
              <div className='form-group my-2 mx-1'>
                <label>فاصله از بالا</label>
                <input
                  type='number'
                  value={eventContext.idCardFields?.fields?.find(f=>f?.name == item?.name)?.['top_' + item?.name]}
                  onChange={(e) =>
                    onChangeValue(
                      `top_${item.name}`,
                      e.target.value,
                      fieldChange.image,
                      item.name,
                      item.label,
                    )
                  }
                  name={`top_${item.name}`}
                  className='form-control f-12'
                />
              </div>
              <div className='form-group my-2 mx-1'>
                <label>فاصله از راست</label>
                <input
                  type='number'
                  value={eventContext.idCardFields?.fields?.find(f=>f?.name == item?.name)?.['right_' + item?.name]}
                  onChange={(e) =>
                    onChangeValue(
                      `right_${item.name}`,
                      e.target.value,
                      fieldChange.image,
                      item.name,
                      item.label,
                    )
                  }
                  name={`right_${item.name}`}
                  className='form-control f-12'
                />
              </div>
            </div>
            <div className='d-flex flex-row justify-content-around'>
              <div className='form-group my-2 mx-1'>
                <label>فاصله از چپ</label>
                <input
                  type='number'
                    value={eventContext.idCardFields?.fields?.find(f=>f?.name == item?.name)?.['left_' + item?.name]}
                  onChange={(e) =>
                    onChangeValue(
                      `left_${item.name}`,
                      e.target.value,
                      fieldChange.image,
                      item.name,
                      item.label,
                    )
                  }
                  name={`left_${item.name}`}
                  className='form-control f-12'
                />
              </div>
              <div className='form-group my-2 mx-1'>
                <label>فاصله از پایین</label>
                <input
                  type='number'
                    value={eventContext.idCardFields?.fields?.find(f=>f?.name == item?.name)?.['bottom_' + item?.name]}
                  onChange={(e) =>
                    onChangeValue(
                      `bottom_${item.name}`,
                      e.target.value,
                      fieldChange.image,
                      item.name,
                      item.label,
                    )
                  }
                  name={`bottom_${item.name}`}
                  className='form-control f-12'
                />
              </div>
            </div>
            {/*<div className='d-flex flex-row'>
                    <button className='d-flex flex-row justify-content-center btn text-center align-content-center f-12 btn-info d-flex my-2 form-control'>
                        اضافه کردن
                    </button>
        </div>*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormFields;
